/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyRefundPayments } from 'app/entities/pharmacy-refund-payment/pharmacy-refund-payment.reducer';
import { getEntities as getPharmacyBillPayments } from 'app/entities/pharmacy-bill-payment/pharmacy-bill-payment.reducer';
import { getEntities as getPharmacySaleCredits } from 'app/entities/pharmacy-sale-credit/pharmacy-sale-credit.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacyConsumers } from 'app/entities/pharmacy-consumer/pharmacy-consumer.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { TransactionType } from 'app/shared/model/enumerations/transaction-type.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-sale-credit-payment-tracker.reducer';

export const PharmacySaleCreditPaymentTrackerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyRefundPayments = useAppSelector(state => state.pharmacyRefundPayment.entities);
  const pharmacyBillPayments = useAppSelector(state => state.pharmacyBillPayment.entities);
  const pharmacySaleCredits = useAppSelector(state => state.pharmacySaleCredit.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyConsumers = useAppSelector(state => state.pharmacyConsumer.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pharmacySaleCreditPaymentTrackerEntity = useAppSelector(state => state.pharmacySaleCreditPaymentTracker.entity);
  const loading = useAppSelector(state => state.pharmacySaleCreditPaymentTracker.loading);
  const updating = useAppSelector(state => state.pharmacySaleCreditPaymentTracker.updating);
  const updateSuccess = useAppSelector(state => state.pharmacySaleCreditPaymentTracker.updateSuccess);
  const transactionTypeValues = Object.keys(TransactionType);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-sale-credit-payment-tracker${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyRefundPayments({}));
    dispatch(getPharmacyBillPayments({}));
    dispatch(getPharmacySaleCredits({}));
    dispatch(getPharmacies({}));
    dispatch(getPharmacyConsumers({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.settledAmount !== undefined && typeof values.settledAmount !== 'number') {
      values.settledAmount = Number(values.settledAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacySaleCreditPaymentTrackerEntity,
      ...values,
      refundPayment: pharmacyRefundPayments.find(it => it.id.toString() === values.refundPayment?.toString()),
      salePayment: pharmacyBillPayments.find(it => it.id.toString() === values.salePayment?.toString()),
      parentCredit: pharmacySaleCredits.find(it => it.id.toString() === values.parentCredit?.toString()),
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      payedCredit: pharmacySaleCredits.find(it => it.id.toString() === values.payedCredit?.toString()),
      consumer: pharmacyConsumers.find(it => it.id.toString() === values.consumer?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          transactionType: 'DEBIT_IN',
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacySaleCreditPaymentTrackerEntity,
          refundPayment: pharmacySaleCreditPaymentTrackerEntity?.refundPayment?.id,
          salePayment: pharmacySaleCreditPaymentTrackerEntity?.salePayment?.id,
          parentCredit: pharmacySaleCreditPaymentTrackerEntity?.parentCredit?.id,
          pharmacy: pharmacySaleCreditPaymentTrackerEntity?.pharmacy?.id,
          payedCredit: pharmacySaleCreditPaymentTrackerEntity?.payedCredit?.id,
          consumer: pharmacySaleCreditPaymentTrackerEntity?.consumer?.id,
          patient: pharmacySaleCreditPaymentTrackerEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.home.createOrEditLabel"
            data-cy="PharmacySaleCreditPaymentTrackerCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.home.createOrEditLabel">
              Create or edit a PharmacySaleCreditPaymentTracker
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-sale-credit-payment-tracker-id"
                  label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.settledAmount')}
                id="pharmacy-sale-credit-payment-tracker-settledAmount"
                name="settledAmount"
                data-cy="settledAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="settledAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.settledAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.transactionType')}
                id="pharmacy-sale-credit-payment-tracker-transactionType"
                name="transactionType"
                data-cy="transactionType"
                type="select"
              >
                {transactionTypeValues.map(transactionType => (
                  <option value={transactionType} key={transactionType}>
                    {translate(`tinyMedicRestApp.TransactionType.${transactionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="transactionTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.transactionType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.addedById')}
                id="pharmacy-sale-credit-payment-tracker-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <UncontrolledTooltip target="addedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.addedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.modifiedById')}
                id="pharmacy-sale-credit-payment-tracker-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <UncontrolledTooltip target="modifiedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.modifiedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.addedByType')}
                id="pharmacy-sale-credit-payment-tracker-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="addedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.addedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.modifiedByType')}
                id="pharmacy-sale-credit-payment-tracker-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="modifiedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.modifiedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.active')}
                id="pharmacy-sale-credit-payment-tracker-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.cursor')}
                id="pharmacy-sale-credit-payment-tracker-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.timestampEntry')}
                id="pharmacy-sale-credit-payment-tracker-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.microSec')}
                id="pharmacy-sale-credit-payment-tracker-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.lastUpdated')}
                id="pharmacy-sale-credit-payment-tracker-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-refundPayment"
                name="refundPayment"
                data-cy="refundPayment"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.refundPayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundPayments
                  ? pharmacyRefundPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-salePayment"
                name="salePayment"
                data-cy="salePayment"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.salePayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBillPayments
                  ? pharmacyBillPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-parentCredit"
                name="parentCredit"
                data-cy="parentCredit"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.parentCredit')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySaleCredits
                  ? pharmacySaleCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-payedCredit"
                name="payedCredit"
                data-cy="payedCredit"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.payedCredit')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySaleCredits
                  ? pharmacySaleCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-consumer"
                name="consumer"
                data-cy="consumer"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.consumer')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumers
                  ? pharmacyConsumers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-payment-tracker-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.pharmacySaleCreditPaymentTracker.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-sale-credit-payment-tracker"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacySaleCreditPaymentTrackerUpdate;
